module.exports = __webpack_public_path__ + "static/media/IBMPlexSans-Regular.c02b4dc6.ttf";